import urls from '../../../constants/urls';

import { gatherErrors } from '../../../utils/errorHandling';

import { ORGANISATIONS_API_CLIENT } from '../../../middleware/multiClientHandler';
import { filter } from 'lodash';
import { paginationParams } from '../../../utils/pagination';
export const LOADING_ORGANISATION = 'admin/organisation/LOADING_ORGANISATION';
export const ORGANISATION_LOAD_FAILED =
  'admin/organisation/ORGANISATION_LOAD_FAILED';
export const ORGANISATION_LOAD_SUCCESS =
  'admin/organisation/ORGANISATION_LOAD_SUCCESS';

export const UPDATE_ORGANISATION_FAILED =
  'admin/organisation/UPDATE_ORGANISATION_FAILED';
export const UPDATE_ORGANISATION_SUCCESS =
  'admin/organisation/UPDATE_ORGANISATION_SUCCESS';
export const UPDATING_ORGANISATION = 'admin/organisation/UPDATING_ORGANISATION';

export const LOADING_ORGANISATION_HOSPITALS =
  'admin/organisation/LOADING_ORGANISATION_HOSPITALS';
export const ORGANISATION_HOSPITALS_LOAD_FAILED =
  'admin/organisation/ORGANISATION_HOSPITALS_LOAD_FAILED';
export const ORGANISATION_HOSPITALS_LOAD_SUCCESS =
  'admin/organisation/ORGANISATION_HOSPITALS_LOAD_SUCCESS';

export const REMOVING_ORGANISATION_HOSPITAL =
  'admin/organisation/REMOVING_ORGANISATION_HOSPITAL';
export const REMOVE_ORGANISATION_HOSPITAL_SUCCESS =
  'admin/organisation/REMOVE_ORGANISATION_HOSPITAL_SUCCESS';
export const REMOVE_ORGANISATION_HOSPITAL_FAILED =
  'admin/organisation/REMOVE_ORGANISATION_HOSPITAL_FAILED';

const initialState = {
  organisation: null,
  organisationHospitals: [],

  failedLoading: false,
  failedSaving: false,

  isLoading: false,
  isSaving: false,

  updateErrors: {},

  loadingOrganisationHospitals: false,
  failedLoadingOrganisationHospitals: false,

  failedRemovingOrganisationHospital: false,
  removingOrganisationHospital: false,

  page: 1,
  pages: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORGANISATION:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case ORGANISATION_LOAD_SUCCESS:
      return {
        ...state,
        organisation: action.payload.data.data,
        isLoading: false,
      };

    case ORGANISATION_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case UPDATING_ORGANISATION:
      return {
        ...state,
        updateErrors: {},
        failedSaving: false,
        isSaving: true,
      };

    case UPDATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        updateErrors: {},
        isSaving: false,
      };

    case UPDATE_ORGANISATION_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(action.error, 'update_organisation_failed'),
        failedSaving: true,
        isSaving: false,
      };

    case LOADING_ORGANISATION_HOSPITALS:
      return {
        ...state,
        loadingOrganisationHospitals: true,
        failedLoadingOrganisationHospitals: false,
      };

    case ORGANISATION_HOSPITALS_LOAD_SUCCESS:
      return {
        ...state,
        organisationHospitals: action.payload.data.data,
        ...paginationParams(
          action.payload.headers['link'],
          action.payload.headers['x-total']
        ),
        loadingOrganisationHospitals: false,
      };

    case ORGANISATION_HOSPITALS_LOAD_FAILED:
      return {
        ...state,
        loadingOrganisationHospitals: false,
        failedLoadingOrganisationHospitals: true,
      };
    case REMOVING_ORGANISATION_HOSPITAL:
      return {
        ...state,
        removingOrganisationHospital: true,
        failedRemovingOrganisationHospital: false,
      };

    case REMOVE_ORGANISATION_HOSPITAL_SUCCESS:
      let removedHospitalId = action.meta.previousAction.hospital.id;

      return {
        ...state,
        removingOrganisationHospital: false,
        organisationHospitals: filter(
          state.organisationHospitals,
          hospital => hospital.id !== removedHospitalId
        ),
      };

    case REMOVE_ORGANISATION_HOSPITAL_FAILED:
      return {
        ...state,
        removingOrganisationHospital: false,
        failedRemovingOrganisationHospital: true,
      };
    default:
      return state;
  }
};

export const loadOrganisation = organisationId => dispatch => {
  return dispatch({
    types: [
      LOADING_ORGANISATION,
      ORGANISATION_LOAD_SUCCESS,
      ORGANISATION_LOAD_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        url: urls.organisationsApi.organisations.admins.show(organisationId),
      },
    },
  });
};

export const updateOrganisation = (organisationId, params) => dispatch => {
  const organisationParams = {
    name: params.name,
    messaging_enabled: params.messaging_enabled,
    nhs_auth_enabled: params.nhs_auth_enabled,
    nhs_session_length_in_hours: params.nhs_session_length_in_hours,
    role_based_messaging_enabled: params.role_based_messaging_enabled,
    critical_alerts_enabled: params.critical_alerts_enabled,
    message_storage_duration: params.message_storage_duration,
    directory_monitoring_enabled: params.directory_monitoring_enabled,
    locking_numbers_enabled: params.locking_numbers_enabled,
  };

  return dispatch({
    types: [
      UPDATING_ORGANISATION,
      UPDATE_ORGANISATION_SUCCESS,
      UPDATE_ORGANISATION_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        method: 'put',
        url: urls.organisationsApi.organisations.admins.update(organisationId),
        data: { organisation: organisationParams },
      },
    },
  });
};

export const loadOrganisationHospitals = (
  page = 1,
  organisationId
) => dispatch => {
  return dispatch({
    types: [
      LOADING_ORGANISATION_HOSPITALS,
      ORGANISATION_HOSPITALS_LOAD_SUCCESS,
      ORGANISATION_HOSPITALS_LOAD_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        url: urls.organisationsApi.organisations.admins.hospitals.index(
          organisationId
        ),
        params: { page, per_page: 50 },
      },
    },
  });
};

export const deleteOrganisationHospital = (
  organisation,
  hospital
) => dispatch => {
  return dispatch({
    types: [
      REMOVING_ORGANISATION_HOSPITAL,
      REMOVE_ORGANISATION_HOSPITAL_SUCCESS,
      REMOVE_ORGANISATION_HOSPITAL_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        method: 'delete',
        url: urls.organisationsApi.organisations.admins.hospitals.destroy(
          organisation.id,
          hospital.id
        ),
      },
    },
    hospital: hospital,
  });
};
